import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { forkJoin, Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { filter, retry, takeUntil } from 'rxjs/operators';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { HttpcallService } from '../../../common/services/httpcall.service';
import { LoginService } from '../../../common/services/Login.service';
import { OpenLinkById } from '../../../common/services/openlinkbyid';
import { SessionService } from '../../../common/services/Session.service';
import { constObj } from '../../../common/Constants/constants';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../common/shared-components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-show-allin-one-page',
  templateUrl: './show-allin-one-page.component.html',
  styleUrls: ['./show-allin-one-page.component.css']
})
export class ShowAllinOnePageComponent implements OnInit, OnDestroy, AfterViewChecked {
  isMacFirefoxUser: boolean = false;
  constructor(private router: Router, private route: ActivatedRoute, public commonDataService: CommonDataService, private httpCallService: HttpcallService,
    private browserTitle: Title, private graphQLService: GraphqlService, private session: SessionService, private loginService: LoginService,
    private elementRef: ElementRef, private sanitizer: DomSanitizer, private openLink: OpenLinkById, public dialog: MatDialog) {
    this.isArchiveApplication();
    this.isMacFirefoxUser = (/firefox/i.test(navigator.userAgent))
  }
  PublPageIds;
  count = 0;
  filteredCards = [];
  Reccord_available: boolean = true;
  pageinitiated: boolean = false;
  mainsectionsectionname;
  prev = 0;
  printqueueAdded: boolean = false;
  parentlevel: boolean = false;
  count_pages = 0;
  outcome: boolean = false;
  s3ImageBasePath: string = "";
  annotationCount: any = {};
  bookmarkCount: any = {};
  annotationContentBool: boolean = false;
  annotationPrintContentBool: boolean = false;
  private destroy$: Subject<void> = new Subject<void>();
  originalDisplayAnnotation: boolean = false;
  isFirefoxUser: boolean = false;
  

  ngOnInit(): void {
    //const prevurl: string = localStorage.getItem("prevUrl");
    //var cururl: string = window.location.href;
    //if (prevurl == cururl) {
    //  this.getPrintSession();
    //} else {
    //  this.commonDataService.resetPrintQueue.pipe(takeUntil(this.destroy$)).subscribe(data => {
    //    this.paragraphIdsList = [];
    //    localStorage.setItem("SetPrintQueueSession", JSON.stringify({}));    //    
    //  });
    this.outcome = false;
    this.PublPageIds = [];
    this.commonDataService.showLoader.next(true);
    this.PublPageIds = JSON.parse(localStorage.getItem("publpageId"));
    this.commonDataService.displayallannotation.next("default");
    this.isArchiveApplication();
    this.commonDataService.annotationWithinContent.subscribe(data => {
      if (data != "" && data != null) {
        this.commonDataService.showLoader.next(true);
        this.annotationContentBool = false;
        this.annotationPrintContentBool = false;
        this.fetchPageAnnotations("displayallannotations", data);
        this.commonDataService.annotationWithinContent.next("");
      }
    });
    this.commonDataService.displayallannotation.subscribe(data => {
      if (data == "displayallannotations" || data == "displayallannotationswithprint") {
        this.commonDataService.showLoader.next(true);
        this.annotationPrintContentBool = false;
        this.annotationContentBool = false;
        this.fetchPageAnnotations(data, "");
      }
      else if (data == "hidePrintallannotations") {
        this.annotationPrintContentBool = false;
        if (this.originalDisplayAnnotation) { this.fetchPageAnnotations("displayallannotations", ""); }
        this.paragraphForAnnotation = [];
      }
      else if (data == "hideallannotations") {
        this.annotationContentBool = false;
        this.originalDisplayAnnotation = false;
        this.annotationPrintContentBool = false;
        this.paragraphForAnnotation = [];
      }
      else {
        this.annotationPrintContentBool = false;
        this.annotationContentBool = false;
      }
    });


    let routeParts = this.router.url.replace("/showallinonepage", "").split("/");
    let routeNavPath = routeParts.join("-");
    this.PublPageIds = JSON.parse(localStorage.getItem("publpageId"));
    if (this.PublPageIds == null || (this.PublPageIds[0].sectionarray[0].pageNavPath != routeNavPath + "-00")) {
      this.getBreadcrumbWithNavPath(routeNavPath);
    } else {
      this.loadShowAll();
    }
    this.commonDataService.addAnnotationParagraphId.subscribe(data => {
      if (data != "") {
        this.annotationCount[data] = parseInt((this.annotationCount[data] == undefined || this.annotationCount[data] == null) ? '0' : this.annotationCount[data]) + 1;
        this.commonDataService.addAnnotationParagraphId.next("");
        if (this.annotationContentBool && this.paragraphForAnnotation.includes(data)) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", data);
        } else if (this.annotationContentBool && this.paragraphForAnnotation.length == 0) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", "");
        }
      }
    })

    this.commonDataService.updateAnnotationParagraphId.subscribe(data => {
      if (data != "" && data != null) {
        if (this.annotationContentBool && this.paragraphForAnnotation.includes(data)) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", data);
        } else if (this.annotationContentBool && this.paragraphForAnnotation.length == 0) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", "");
        }
      }
    })
    this.commonDataService.deleteAnnotationParagraphId.subscribe(data => {
      if (data != "") {
        this.annotationCount[data] = parseInt((this.annotationCount[data] == undefined || this.annotationCount[data] == null) ? '0' : this.annotationCount[data]) - 1;
        if (this.annotationContentBool && this.paragraphForAnnotation.includes(data)) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", data);
        } else if (this.annotationContentBool && this.paragraphForAnnotation.length == 0) {
          this.commonDataService.showLoader.next(true);
          this.annotationContentBool = false;
          this.annotationPrintContentBool = false;
          this.fetchPageAnnotations("displayallannotations", "");
        }
        this.commonDataService.deleteAnnotationParagraphId.next("");
      }
    })
    this.commonDataService.addBookmarkParagraphId.subscribe(data => {
      if (data != "") {
        this.bookmarkCount[data] = parseInt((this.bookmarkCount[data] == undefined || this.bookmarkCount[data] == null) ? '0' : this.bookmarkCount[data]) + 1;
        this.commonDataService.addBookmarkParagraphId.next("");
      }
    })
    this.commonDataService.deleteBookmarkParagraphId.subscribe(data => {
      if (data != "") {
        this.bookmarkCount[data] = parseInt((this.bookmarkCount[data] == undefined || this.bookmarkCount[data] == null) ? '0' : this.bookmarkCount[data]) - 1;
        this.commonDataService.deleteBookmarkParagraphId.next("");
      }
    })

    this.commonDataService.printCount.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data == "toggleOff") {
        this.paragraphIdsList = [];
        this.showAllPrintQueue = JSON.parse(localStorage.getItem("OriginalPrintQueue")) == null ? [] : JSON.parse(localStorage.getItem("OriginalPrintQueue"));
      }
    })

    this.event$ = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        this.firstTimeFlag = false;
        routeParts = this.router.url.replace("/showallinonepage", "").split("/");
        routeNavPath = routeParts.join("-");
        this.isArchiveApplication();
        if (this.PublPageIds == null || (this.PublPageIds[0].sectionarray[0].pageNavPath != routeNavPath + "-00")) {
          this.getBreadcrumbWithNavPath(routeNavPath);
        }
        else {
          this.loadShowAll();
        }

      });
  }
  firstTimeFlag: boolean = true;
  ngAfterViewChecked() {

    if (this.firstTimeFlag && this.outcome) {
      this.firstTimeFlag = false;
      this.getstatusStylings();
      //this.setLineBreak();
      if (this.elementRef.nativeElement.querySelector('.inline-glossary')) {
        this.elementRef.nativeElement.querySelector('.inline-glossary').addEventListener('click', this.redirectInlineGlossary.bind(this));
      }
    }
   
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.syncTopAndBottomScroll();
      this.observeTable();
    }, 0);
  }
  observeTable(): void {
    const observer = new MutationObserver(() => {
      this.syncTopAndBottomScroll();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  syncTopAndBottomScroll(): void {
    const topScrolls = document.querySelectorAll('.top-scroll');
    const bottomScrolls = document.querySelectorAll('.bottom-scroll');
    if (!topScrolls.length || !bottomScrolls.length) return;
    topScrolls.forEach((top, index) => {
      const bottom = bottomScrolls[index] as HTMLElement;
      const topElement = top as HTMLElement;
      if (!bottom) return;
      const topInner = topElement.firstElementChild as HTMLElement;
      if (topInner) {
        topInner.style.width = bottom.scrollWidth + 'px';
      }
      topElement.addEventListener('scroll', () => {
        bottom.scrollLeft = topElement.scrollLeft;
      });
      bottom.addEventListener('scroll', () => {
        topElement.scrollLeft = bottom.scrollLeft;
      });
    });
  }
  archiveVersion: string = "";
  isArchive: boolean = false;
  isArchiveApplication() {
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      this.isArchive = true;
      this.archiveVersion = this.convertMonthYear(localStorage.getItem("ArchiveVersion"));
    }
    //else if (this.router.url.split("/")[1] != localStorage.getItem("currentVersionPublicationId")) {
    //  this.isArchive = true;
    //  this.archiveVersion = localStorage.getItem("ArchiveVersion");
    //  this.commonDataService.loadCurrentLeftNav.next(this.router.url.split("/")[1]);
    //}
    else { this.isArchive = false; }
  }

  role: string = "";
  paragraphForAnnotation: string[] = [];
  pageAnnotationsForPrint: any = {};
  pageAnnotations: any = {};
  fetchPageAnnotations(option, paragraphId) {
    if (this.mailId != "" && this.mailId != null) {
      let inputBody = { "NavigationPath": "GARS", "Application": "GARS", "paragraphId": paragraphId };
      this.httpCallService.getPageAnnotation(inputBody).subscribe(data => {
        if (option == "displayallannotations") {
          if (paragraphId != "") {
            if (this.pageAnnotations == {} || this.paragraphForAnnotation.length == 0) {
              this.pageAnnotations = data;
              if (!this.paragraphForAnnotation.includes(paragraphId)) {
                this.paragraphForAnnotation.push(paragraphId);
              }
            } else {
              this.pageAnnotations[paragraphId] = data[paragraphId];
              if (!this.paragraphForAnnotation.includes(paragraphId)) {
                this.paragraphForAnnotation.push(paragraphId);
              }
            }
          } else {
            this.paragraphForAnnotation = [];
            this.pageAnnotations = data;
            this.originalDisplayAnnotation = true;
          }
          this.commonDataService.showLoader.next(false);
          this.annotationContentBool = true;
        } else if (option == "displayallannotationswithprint") {
          this.pageAnnotationsForPrint = data;
          this.commonDataService.showLoader.next(false);
          this.annotationPrintContentBool = true;
        }
      })
    }
  }

  loadShowAll() {
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    if (leftNavigation == undefined || leftNavigation == null) {
      this.graphQLService.GetBreadcrumbSession(this.PublPageIds[0].sectionarray[0].publid + "/" + this.PublPageIds[0].sectionarray[0].pageid).subscribe(data => {
        this.crumbData = JSON.parse(JSON.stringify(data)).crumbData;
        this.postBreadcrumbData(this.crumbData)
      });
    }
    else {
      this.getBreadcrumb(this.PublPageIds);
      this.postBreadcrumbData(this.crumbData)
    }
    this.showAllContent = [];
    this.showAllFootnote = [];
    this.showAllPrintQueue = [];
    this.showAllPageHeadings = [];
    this.containsFootnote = false;
    this.loadAllPages();
    this.getPrintSession();
   
    document.querySelector("app-main-content").scrollTop = 0
  }

  event$: Subscription;
  HistoryCrumbData: string = "";
  linkerList: any= {};
  mainCalls$: Subscription;
  isAcademic: boolean = false;
  loadAllPages() {
    this.HistoryCrumbData = this.crumbData.slice(0, 1).join("~");
    let showAllPath: string = "";
    let allPagesHeader: any = [];
    let allHistoryHeader: any = [];
    if (this.PublPageIds.length == 1) {
      let navPath = this.PublPageIds[0].sectionarray[0].pageNavPath.split("-");
      navPath.pop();
      showAllPath = navPath.join("-");
    }
    else if (this.PublPageIds.length > 1) {
      let navPath = this.PublPageIds[0].sectionarray[0].pageNavPath.split("-");
      navPath.pop();
      navPath.pop();
      showAllPath = navPath.join("-");
    }
    for (let j = 0; j < this.PublPageIds.length; j++) {
      for (let i = 0; i < this.PublPageIds[j].sectionarray.length; i++) {
        let breadcrumb = this.PublPageIds[j].mainsectionname == this.PublPageIds[j].sectionname ? this.HistoryCrumbData + "~" + this.PublPageIds[j].mainsectionname + "~" + this.PublPageIds[j].sectionarray[i].pagetitle : this.HistoryCrumbData + "~" + this.PublPageIds[j].mainsectionname + "~" + this.PublPageIds[j].sectionname + "~" + this.PublPageIds[j].sectionarray[i].pagetitle;
        let PageHeader = { "publicationId": this.PublPageIds[0].sectionarray[0].publid, "pageIds": this.PublPageIds[j].sectionarray[i].pageid, "navPath": this.PublPageIds[j].sectionarray[i].pageNavPath, "pageName": this.PublPageIds[j].sectionarray[i].pagetitle, "navTitlePath": breadcrumb, "isArchive": this.isArchive };
        let historyHeader = { "BreadCrumb": breadcrumb, "NavPath": breadcrumb, "PageURL": this.PublPageIds[0].sectionarray[0].publid + "/" + this.PublPageIds[j].sectionarray[i].pageid };
        allPagesHeader.push(PageHeader);
        allHistoryHeader.push(historyHeader);
      }
    }
    let showAllInOnePageHeader = { "showAllPagePath": showAllPath, "allPagesHeaderList": allPagesHeader }
    if (this.PublPageIds.length != 1) {
      this.parentlevel = true;
      this.commonDataService.parentlevelshowallinone.next(this.parentlevel);
    } else {

      this.commonDataService.parentlevelshowallinone.next(false);
    }

    this.mainsectionsectionname = this.PublPageIds[0].mainsectionname;
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(loginData => {
        if (loginData != null) {
          this.loggedInUserInfo = loginData;
          this.userId = this.loggedInUserInfo.user.userName;
          this.mailId = this.loggedInUserInfo.user.email;
          this.role = this.loggedInUserInfo.user.roles;
          if (this.loggedInUserInfo.user.roles == "Academic") {
            this.isAcademic = true;
          }
          
            let saveHistoryHeader = { "Id": "-1", "UpdateUserId": "", "ApplicationSource": "GARS", "CreateDate": "", "UpdateDate": "", "allHistoryHeader": allHistoryHeader };
            let paragraphActionInputBody = { NavigationPath: "GARS", Application: "" };
            this.mainCalls$ = forkJoin([this.graphQLService.getS3BucketImagePath(), this.graphQLService.getShowAllPageData(showAllInOnePageHeader).pipe(retry(3)),
              this.graphQLService.getLinkerList(), this.graphQLService.getGlobalLabels()
            ])
              .subscribe(([s3ImagePath, pageData, linkerList, globalLabels]) => {
                this.s3ImageBasePath = s3ImagePath;
                this.linkerList = linkerList;
                this.getFormattedData(pageData);
                this.getActionMenuLabels(globalLabels);
                this.outcome = true;
                this.commonDataService.showLoader.next(false);
                if (this.loggedInUserInfo.user.role != "Basic" && (!this.isArchive)) {
                  forkJoin([
                    this.httpCallService.getBookmarkCount(paragraphActionInputBody),
                    this.httpCallService.getAnnotationCount(paragraphActionInputBody)])
                    .subscribe(([bookmarkCount, annotationCount]) => {
                      this.bookmarkCount = bookmarkCount; this.annotationCount = annotationCount;
                      this.httpCallService.addAllHistory(saveHistoryHeader).subscribe(historyResponse => { console.log(historyResponse); });
                    })
                }
              }, err => {
                console.log(err);
                this.commonDataService.showLoader.next(false);
              });
        }
      })
    }
    else {
        this.userId = this.session.userInfo.user.userName;
      this.mailId = this.session.userInfo.user.email;
      this.role = this.session.userInfo.user.roles;
        if (this.session.userInfo.user.roles == "Academic") {
          this.isAcademic = true;
        }
        let saveHistoryHeader = { "Id": "-1", "UpdateUserId": "", "ApplicationSource": "GARS", "CreateDate": "", "UpdateDate": "", "allHistoryHeader": allHistoryHeader };
        let paragraphActionInputBody = { NavigationPath: "GARS", Application: "" };
        this.mainCalls$ = forkJoin([this.graphQLService.getS3BucketImagePath(),
          this.graphQLService.getShowAllPageData(showAllInOnePageHeader).pipe(retry(3)), this.graphQLService.getLinkerList(),
              this.graphQLService.getGlobalLabels()])
          .subscribe(([s3ImagePath, pageData, linkerList, globalLabels]) => {
            this.loggedInUserInfo = this.session.userInfo;
            this.s3ImageBasePath = s3ImagePath;
            this.linkerList = linkerList;
            this.getFormattedData(pageData); this.getActionMenuLabels(globalLabels);
            this.outcome = true;
            this.commonDataService.showLoader.next(false);
            if (this.session.userInfo.user.roles != 'Basic' && (!this.isArchive)) {
              forkJoin([
                this.httpCallService.getBookmarkCount(paragraphActionInputBody),
                this.httpCallService.getAnnotationCount(paragraphActionInputBody),
                this.httpCallService.addAllHistory(saveHistoryHeader)])
                .subscribe(([bookmarkCount, annotationCount, historyResponse]) => {
                  this.bookmarkCount = bookmarkCount; this.annotationCount = annotationCount;
                  console.log(historyResponse);
                })
              this.httpCallService.addAllHistory(saveHistoryHeader).subscribe(historyResponse => { console.log(historyResponse); });
            }
          }, err => {
            console.log(err);
            this.commonDataService.showLoader.next(false);
          });
    }
  }
  containsFootnote: boolean = false;
  showAllFootnote: any[] = [];
  showAllPageHeadings: any[] = [];
  showAllContent: any[] = [];
  showAllPrintQueue: any[] = [];
  getFormattedData(showAllContent) {
    let tempArr: any[] = [];
    for (let x = 0; x < this.PublPageIds[0].sectionarray.length; x++) {
      let body = showAllContent[this.PublPageIds[0].sectionarray[x].pageNavPath];
      this.outcome = true;
      this.commonDataService.showLoader.next(false);
      let pageHeading = body.headingName == "" ? this.PublPageIds[0].sectionarray[x].pagetitle : this.sanitizer.bypassSecurityTrustHtml(body.headingName.split("____")[0]);
      //this.showAllContent.push(body.paragraphContent.filter(x => x.paraContent = this.sanitizer.bypassSecurityTrustHtml(x.paraContent)));
      if (body.paragraphContent != null) {
        for (let i = 0; i < body.paragraphContent.length; i++) {
          if (body.paragraphContent[i].paragraphHeading != null) {
            let tempParaHeadingId = [];
            for (let j = 0; j < body.paragraphContent[i].paragraphHeading.length; j++) {
              tempParaHeadingId.push(body.paragraphContent[i].paragraphHeading[j] != "" ? body.paragraphContent[i].paragraphHeading[j].split('____')[1] : "");
              body.paragraphContent[i].paragraphHeading[j] = body.paragraphContent[i].paragraphHeading[j] != "" ? this.sanitizer.bypassSecurityTrustHtml(body.paragraphContent[i].paragraphHeading[j].split('____')[0]): "";
            }
            body.paragraphContent[i].paragraphHeadingId = tempParaHeadingId;
          }
          body.paragraphContent[i].paraContent = this.sanitizer.bypassSecurityTrustHtml(body.paragraphContent[i].paraContent);
        }
      }
      this.showAllContent.push(body.paragraphContent);
      this.showAllPageHeadings.push(pageHeading);
      this.showAllFootnote.push(body.footnote.filter(y => y.footnoteBody = this.sanitizer.bypassSecurityTrustHtml(y.footnoteBody)));
      tempArr.push(body.printParagraphs);
      if (body.footnote?.length > 0) {
        this.containsFootnote = true;
      }
    }
    this.showAllPrintQueue = tempArr;
    localStorage.setItem("OriginalPrintQueue", JSON.stringify(this.showAllPrintQueue));
  }

  postBreadcrumbData(crumbData) {
    //this.commonDataService.navDataContentPage.next(crumbData);
    //this.commonDataService.breadcrumbPath.next(this.breadcrumbPath);
    //crumbData.pop();
    this.breadcrumbPath = crumbData.join("~");

    this.browserTitle.setTitle("Combine Sections - " + this.PublPageIds[0].mainsectionname);
  }

  breadcrumbPath: string = "";
  navData;
  tempdata;

  loggedInUserInfo;
  menuListItems: any = [];
  labelItems: any;
  getActionMenuLabels(data) {
    this.menuListItems = [];
    if (data != "") {
      let labels = data.content.data.labels;
      this.labelItems = labels;
      labels = labels.filter(x => x.key.trim());
      if (this.role != 'Basic' && (!this.isArchive)) {
        this.menuListItems.push(labels.filter(x => x.key == "addBookmark_header").map(y => y.value)[0]);
        this.menuListItems.push(labels.filter(x => x.key == "addAnnotation_header").map(y => y.value)[0]);
        this.menuListItems.push(labels.filter(x => x.key == "provideFeedback_header").map(y => y.value)[0]);
      }
      this.menuListItems.push(labels.filter(x => x.key == "print_addToQueue").map(y => y.value)[0]);
      if (this.role != 'Basic' && (!this.isArchive)) {
        this.menuList = [
          {
            menuLinkText: this.menuListItems[0],
            isDisabled: this.isAcademic,
            value: undefined,
            isToggle: false,
            imgPath: '../../../assets/icons/BookmarkAdd.svg'
          },
          {
            menuLinkText: this.menuListItems[1],
            isDisabled: this.isAcademic,
            value: undefined,
            isToggle: false,
            imgPath: '../../../assets/icons/pencil-alt.svg'
          },
          {
            menuLinkText: this.menuListItems[3],
            isDisabled: false,
            value: true,
            isToggle: true,
            imgPath: '../../../assets/icons/Print.svg'
          }
        ];
      }
      else {
        this.menuList = [
          {
            menuLinkText: this.menuListItems[0],
            isDisabled: false,
            value: true,
            isToggle: true,
            imgPath: '../../../assets/icons/Print.svg'
          }
        ];
      }
    }
  }

  ngOnDestroy() {
    if (this.mainCalls$ != undefined) {
      this.mainCalls$.unsubscribe()
    }
    if (this.event$ != undefined) {
      this.event$.unsubscribe()
    }
    this.commonDataService.loadCurrentLeftNav.next(null);
  }
  crumbData;
  getBreadcrumb(pagepublId: any) {
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 0; i < leftNavigation.length; i++) {
      this.crumbData = [];
      if (leftNavigation[i].itemData != null && leftNavigation[i].itemData?.length > 0 && leftNavigation[i].rollUp != "True") {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          if (leftNavigation[i].itemData[j].itemLink != null && leftNavigation[i].itemData[j].itemLink != "" && (leftNavigation[i].itemData[j].itemData?.length == 0 || leftNavigation[i].itemData[j].rollUp == "True")) {
            if (leftNavigation[i].itemData[j].itemLink == pagepublId[0].sectionarray[0].publid + "/" + pagepublId[0].sectionarray[0].pageid) {
              this.crumbData.push(leftNavigation[i].item);
              this.crumbData.push(leftNavigation[i].itemData[j].item);
              return;
            }
          } else {
            if (leftNavigation[i].itemData[j].itemData != null && leftNavigation[i].itemData[j].itemData?.length > 0 && leftNavigation[i].itemData[j].rollUp != "True") {
              for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
                if (leftNavigation[i].itemData[j].itemData[k].itemLink != null && (leftNavigation[i].itemData[j].itemData[k].itemData?.length == 0 || leftNavigation[i].itemData[j].itemData[k].rollUp == "True")) {
                  if (leftNavigation[i].itemData[j].itemData[k].itemLink == pagepublId[0].sectionarray[0].publid + "/" + pagepublId[0].sectionarray[0].pageid) {
                    this.crumbData.push(leftNavigation[i].item);
                    this.crumbData.push(leftNavigation[i].itemData[j].item);
                    this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                    return;
                  }
                }
                else {
                  if (leftNavigation[i].itemData[j].itemData[k].itemData != null && leftNavigation[i].itemData[j].itemData[k].itemData?.length > 0 && leftNavigation[i].itemData[j].itemData[k].rollUp != "True") {
                    for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink != null && (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData?.length == 0 || leftNavigation[i].itemData[j].itemData[k].itemData[l].rollUp == "True")) {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink == pagepublId[0].sectionarray[0].publid + "/" + pagepublId[0].sectionarray[0].pageid) {
                          this.crumbData.push(leftNavigation[i].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                          return;
                        }
                      }
                      else {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null && leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData?.length > 0 && leftNavigation[i].itemData[j].itemData[k].itemData[l].rollUp != "True") {
                          for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].itemLink == pagepublId[0].sectionarray[0].publid + "/" + pagepublId[0].sectionarray[0].pageid) {
                              this.crumbData.push(leftNavigation[i].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item);
                              return;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  paragraphIdsList: any[] = [];
  addedparagraphList = [];

  getPrintSession() {
    this.addedparagraphList = [];
    this.paragraphIdsList = [];
    let printQueueData = JSON.parse(localStorage.getItem("SetPrintQueueSession"));
    if (printQueueData) {
      if (printQueueData != null && printQueueData.ParagraphIdsList != null) {
        this.addedparagraphList = printQueueData.ParagraphIdsList;
        this.paragraphIdsList = printQueueData.ParagraphIdsList;
      }
    }
  }

  BackToCurrentContent() {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    let popUpMessage = constObj.currentVersionNavigationAlert;
    if (printQueueCount > 0) {
      popUpMessage += "<br/>" + constObj.annotationAlertPrintQueue;
    }
    else { popUpMessage += "<br/>" + constObj.continueMessage; }
    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.removeItem("ArchiveVersion");
        this.commonDataService.loadCurrentLeftNav.next(localStorage.getItem("currentVersionPublicationId"));
        this.router.navigateByUrl("/Home");
      }
    });
  }

  openLinkById(event) {
    let id = event.target.id;
    let classname = event.target.classList;
    let termClassName = event.target.parentNode.className;
    if (((id != "" && id.includes(".pdf")) || classname.contains("pdf-link")) && (termClassName != "term" || !classname.contains("term"))) {
      event.preventDefault();
      //this.openLink.openLinkById(event);
      this.popRedirectionHelper(event, 1);
    }
    else if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref" && event.srcElement.href.includes('http') && event.srcElement.href.includes('.pdf')) {
      //window.open(event.srcElement.href);
      this.popRedirectionHelper(event, 2);
    }
    else if (classname.contains("term") || termClassName == "term") {
      event.preventDefault();
      id = id == "" && classname.contains("term") ? event.target.id : id;
      id = id == "" && termClassName == "term" ? event.target.parentNode.id : id;
      if (!this.isArchive) { this.redirectInlineGlossary(id); }
    }
    else if (classname.contains("ditamap")) {
      //console.log(event.target.attributes.altSource.value.replace(".ditamap", ""))
      let guid = event.target.attributes.altSource.value.replace(".ditamap", "");
      //this.router.navigateByUrl(guid + "/tableOfContent");
      this.popRedirectionHelper(guid + "/tableOfContent", 4);
    }
    else {
      this.openLink.redirectToFootnote(event);
    }
  }

  /* Start -- Annonation pop-up for print queue with MS -299 */
  popRedirectionHelper(event, x) {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    if (printQueueCount > 0) {
     // console.log('show-alli-page-viewr-popRedirectionHelper-610');
     /* var temppath: any;
      if (x == 1 || x == 2 || x == 5) {
        temppath = event.composedPath() as Array<any>;
      }*/
      localStorage.setItem("isConfirmPopup", "true");
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.annotationAlertPrintQueue
      });
      /*if (x == 1 || x == 2 || x == 5) {
        dialogRef.componentInstance.temppath = temppath;
      }*/
      dialogRef.afterClosed().subscribe((result: boolean) => {
        localStorage.removeItem("isConfirmPopup");
        if (result == true) {
          switch (x) {
            case 1: {
              this.openLink.openLinkById(event);
              break;
            }
            case 2: {
              window.open(event.srcElement.href);
              break;
            }
            case 3: {
              this.redirectInlineGlossary(event);
              break;
            }
            case 4: {
              this.router.navigateByUrl(event);
              break
            }
            case 5: {
              this.openLink.redirectToFootnote(event, dialogRef.componentInstance.temppath);
              break;
            }
          }
        }
      });
      return;
    }
    else {
      switch (x) {
        case 1: {
          this.openLink.redirectToFootnote(event);
          break;
        }
        case 2: {
          window.open(event.srcElement.href);
          break;
        }
        case 3: {
          this.redirectInlineGlossary(event);
          break;
        }
        case 4: {
          this.router.navigateByUrl(event);
          break
        }
        case 5: {
          this.openLink.redirectToFootnote(event);
          break;
        }
      }
    }
  }
  /* End -- Annonation pop-up for print queue with MS -299 */


  getstatusStylings() {
    let ImageDivs = document.getElementsByClassName("img") as HTMLCollectionOf<HTMLImageElement>;
    if (ImageDivs.length > 0) {
      for (let i = 0; i < ImageDivs.length; i++) {
        ImageDivs[i].onload = function () {
          ImageDivs[i].style.width = String(ImageDivs[i].naturalWidth) + "px";
          ImageDivs[i].style.height = String(ImageDivs[i].naturalHeight) + "px";
          ImageDivs[i].style.maxHeight = '100%';
          ImageDivs[i].style.maxWidth = '100%';
          ImageDivs[i].style.boxSizing = 'border-box';
        }
      }
    }
  }

  onRightClick(event: any) {
    let classname = event.target.classList;
    let termClassName = event.target.parentNode.className;
    if (termClassName == "term" || classname.contains("term")) {
      event.preventDefault();
    }
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref" && event.srcElement.href.includes('http') && event.srcElement.href.includes('.pdf'))
    {
      //window.open(event.srcElement.href);
    }
    else if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref") {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
      event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlParts[otherSourceUrlParts.length - 1]);
    }
  }

  mainsection: string = "";

  pagepublicationId: { publid: string, pageid: string, pagetitle: string, pageurl: any, pageNavPath: string }[] = [];
  pagepubllist: { sectionarray: any[], sectionname: string, mainsectionname: string }[] = [];
  showAllInOnePage(obj) {
    this.pagepublicationId = [];
    this.pagepubllist = [];
    this.getpagepublids(obj);
    if (this.pagepublicationId.length > 0) {
      this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
      this.pagepublicationId = [];
    }
    localStorage.setItem("publpageId", JSON.stringify(this.pagepubllist));
    this.PublPageIds = this.pagepubllist;
    this.loadShowAll();
  }
  getpagepublids(obj) {
    if (obj.itemData.length > 0 && obj.rollUp != 'True') {
      for (let items of obj.itemData) {
        this.getpagepublids(items);
      }
    }
    if (obj.itemLink != null && (obj.itemData?.length == 0 || obj.rollUp == 'True')) {
      let PublpageId = obj.itemLink.split('/').map(d => d);
      let pageTitle = obj.item;
      this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: pageTitle, pageurl: obj.itemLink, pageNavPath: obj.navPath });
    }
    else {
      if (this.pagepublicationId.length > 0) {
        this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
        this.pagepublicationId = [];
      }
    }
  }

  redirectInlineGlossary(id) {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("inline-glossary");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.glossaryTermId.next(id);
  }

  getBreadcrumbWithNavPath(rawBreadcerumbUrl) {
    let breadcerumbUrl = rawBreadcerumbUrl.substring(1);
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 0; i < leftNavigation?.length; i++) {
      if (leftNavigation[i].itemData != null && leftNavigation[i].itemData.length > 0 && leftNavigation[i].rollUp == "False") {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          if (leftNavigation[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            this.mainsection = leftNavigation[i].itemData[j].item;
            this.showAllInOnePage(leftNavigation[i].itemData[j]);
            return;
          } else {
            if (leftNavigation[i].itemData[j].itemData != null && leftNavigation[i].itemData[j].itemData.length > 0 && leftNavigation[i].itemData[j].rollUp == "False") {
              for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
                if (leftNavigation[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  this.mainsection = leftNavigation[i].itemData[j].item;
                  this.showAllInOnePage(leftNavigation[i].itemData[j].itemData[k]);
                  return;
                } else {
                  if (leftNavigation[i].itemData[j].itemData[k].itemData != null && leftNavigation[i].itemData[j].itemData[k].itemData.length > 0 && leftNavigation[i].itemData[j].itemData[k].rollUp == "False") {
                    for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        this.mainsection = leftNavigation[i].itemData[j].itemData[k].item;
                        this.showAllInOnePage(leftNavigation[i].itemData[j].itemData[k].itemData[l]);
                        return;
                      }
                      else {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null && leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length > 0 && leftNavigation[i].itemData[j].itemData[k].itemData[l].rollUp == "False") {
                          for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              this.mainsection = leftNavigation[i].itemData[j].itemData[k].itemData[l].item;
                              this.showAllInOnePage(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m]);
                              return;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return
  }

  userId: string = "";
  mailId: string = "";
  menuList: any = [];
  bookmarkarray: any[];
  deleteBookmark(paragraphId) {
    this.commonDataService.showLoader.next(true);
    this.httpCallService.getBookmark(paragraphId).subscribe((resp: any) => {
      this.bookmarkarray = resp;
      var bookmark = {
        ID: this.bookmarkarray[this.bookmarkarray.length - 1].id, TopicId: this.bookmarkarray[this.bookmarkarray.length - 1].topicId, ParagraphId: paragraphId, BookmarkTitle: this.bookmarkarray[this.bookmarkarray.length - 1].bookmarkTitle, BookMarkBreadCrumb: this.bookmarkarray[this.bookmarkarray.length - 1].bookMarkBreadCrumb, IsDeleted: true, CreatedOn: this.bookmarkarray[this.bookmarkarray.length - 1].createdOn, ModifiedOn: this.bookmarkarray[this.bookmarkarray.length - 1].modifiedOn, ApplicationSource: "GARS",
        BookmarkURL: this.bookmarkarray[this.bookmarkarray.length - 1].bookmarkURL, NavigationPath: "GARS"
      }

      this.httpCallService.addUpdateBookmark(bookmark).toPromise()
        .then(response => {
          //this.closeOverlay();
          this.commonDataService.showLoader.next(false);
          this.bookmarkCount[bookmark.ParagraphId] = parseInt((this.bookmarkCount[bookmark.ParagraphId] == undefined || this.bookmarkCount[bookmark.ParagraphId] == null) ? '0' : this.bookmarkCount[bookmark.ParagraphId]) - 1;
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.bookmarkRemovedMessage
          }
          this.commonDataService.notificationObject.next(obj);
        })
        .catch(console.log);
    }, err => {
      console.log(err)
      this.commonDataService.showLoader.next(false);
    });
  }

  openAnnotations(paragrphId, paragraphHeading, paraNum, pageIteration) {
    this.checkparaheadings(paragraphHeading);
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.currentParagraph.next(this.activeParaId);
    this.commonDataService.rightOverlayOption.next("Your Annotations");
    let breadcrumbs = this.breadcrumbPath.split("~");
    breadcrumbs.pop();
    breadcrumbs.push(this.showAllPageHeadings[pageIteration]);
    this.commonDataService.breadcrumbPath.next(breadcrumbs.join("~"));
    this.commonDataService.navDataContentPage.next(breadcrumbs);
  }

  paratitle: string = "";
  checkparaheadings(paragraphHeading) {
    if (paragraphHeading != null) {
      for (let i = 0; i < paragraphHeading.length; i++) {
        if (paragraphHeading[i] != '' && paragraphHeading[i] != null) {
          let span = document.createElement('span');
          span.innerHTML = paragraphHeading[i];
          this.paratitle = span.innerText.trim().replace(/\s+/g, " ");
          if (this.activeParaNum != "") { this.commonDataService.showRightPanel.next(true); this.commonDataService.currentParagraphId.next(this.activeParaNum); this.activeParaNum = ""; }
          else if (this.paratitle != null && this.paratitle != '') {
            this.commonDataService.showRightPanel.next(true);
            this.commonDataService.currentParagraphId.next(this.paratitle);
          } else {
            this.commonDataService.showRightPanel.next(true);
            this.commonDataService.currentParagraphId.next("");
          }
          break;
        } else if (i == paragraphHeading.length - 1) {
          if (this.activeParaNum != "") {
            this.commonDataService.showRightPanel.next(true);
            this.commonDataService.currentParagraphId.next(this.activeParaNum); this.activeParaNum = "";
          }
          else {
            this.commonDataService.currentParagraphId.next("");
          }
        }
      }
    } else {
      if (this.activeParaNum != "") {
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.currentParagraphId.next(this.activeParaNum); this.activeParaNum = "";
      }
      else {
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.currentParagraphId.next("");
      }
    }
  }

  clickMenuItem(item, action) {
    if (item.isDisabled) { alert("You do not have access to this feature") }
    else {
      let width = "rightOverLay_small";
      if (item.menuLinkText.includes("Bookmark") && action == "Remove") {
        this.deleteBookmark(this.activeParaId)
        return true;
      }
      this.openRightOverlay(item.menuLinkText, width)
    }
  }

  activeParaId: string = "";
  activeParaHeading: string[] = [];
  activeParaNum: string = "";
  activePageIteration: string = "";
  activeParaIteration: string = "";
  printQueue: boolean = false;
  activePageName: any;
  activePageUrl: string = "";
  activeParaChanged(paragrphId, paragraphHeading, paraNum, pageIteration, paraIteration, pageUrl) {
    this.printQueue = this.showAllPrintQueue[pageIteration][paragrphId];
    this.activePageIteration = pageIteration;
    this.activeParaIteration = paraIteration;
    this.activePageName = this.showAllPageHeadings[pageIteration];
    this.activeParaId = paragrphId;
    this.activeParaHeading = paragraphHeading;
    this.activeParaNum = paraNum;
    this.activePageUrl = pageUrl;
  }


  openRightOverlay(str, width) {
    this.checkparaheadings(this.activeParaHeading);
    this.commonDataService.rightPanelWidth.next(width);
    this.commonDataService.currentParagraph.next(this.activeParaId);
    this.commonDataService.pageUrl.next(this.activePageUrl);
    //this.commonDataService.userId.next(this.userId);
    this.commonDataService.mailId.next(this.mailId);
    if (str == "Add Annotation") {
      this.commonDataService.annotationUpdateSource.next("");
    }
    let breadcrumbs = this.breadcrumbPath.split("~");
    //breadcrumbs.pop();
    //breadcrumbs.push(this.activePageName.changingThisBreaksApplicationSecurity);
    this.commonDataService.breadcrumbPath.next(breadcrumbs.join("~"));
    this.commonDataService.navDataContentPage.next(breadcrumbs);
    this.commonDataService.rightOverlayOption.next(str);
  }

  printqueueAddBool: boolean = false;
  public toggle(event: MatSlideToggleChange) {
    this.showAllPrintQueue[this.activePageIteration][this.activeParaId] = event.checked;
    this.commonDataService.printqueueCount.next(event.checked.toString());
    if (event.checked) {
      this.printqueueAdded = true;
      if (this.paragraphIdsList == null) {
        this.paragraphIdsList = [];
      }
      this.paragraphIdsList.push({ key: this.activePageName, value: this.activeParaId, paraHeading: this.activeParaHeading, paraNum: this.activeParaNum, pageNumber: this.activePageIteration, paraIteration: this.activeParaIteration });
      const body = {
        ParagraphIdsList: this.paragraphIdsList
      };
      localStorage.setItem("SetPrintQueueSession", JSON.stringify(body));
    }
    else {
      this.printqueueAdded = false;
      this.remove(this.paragraphIdsList, this.activeParaId);

      const _body = {
        ParagraphIdsList: this.paragraphIdsList,
      };

      localStorage.setItem("SetPrintQueueSession", JSON.stringify(_body));
    }
  }

  remove(arr, what) {
    arr.sort().forEach(function (value, index) {
      if (value.value === what) {
        arr.splice(index, 1);
      }
    });
  }

  convertMonthYear(abbrMonthYear: string): string {
    // Define a map of abbreviated month names to full month names
    const monthMap: { [key: string]: string } = {
      "Jan": "January",
      "Feb": "February",
      "Mar": "March",
      "Apr": "April",
      "May": "May",
      "Jun": "June",
      "Jul": "July",
      "Aug": "August",
      "Sep": "September",
      "Oct": "October",
      "Nov": "November",
      "Dec": "December"
    };

    // Split the input string into month and year parts
    const [abbrMonth, year] = abbrMonthYear.split(" ");

    // Look up the full month name in the map
    const fullMonth = monthMap[abbrMonth];

    // If the abbreviation is not valid, return an error message
    if (!fullMonth) {
      return abbrMonthYear;
    }

    // Return the full month and year as a string
    return `${fullMonth} ${year}`;
  }
}
